const fetch = require('cross-fetch')

/**
 * Sanity query
 * @param {string} query
 * @param {{}} [variables]
 */
const query = (query, variables = {}) => {
  const params = new URLSearchParams({
    query,
    ...variables,
  })
  return fetch(
    `https://sw3vm7m7.api.sanity.io/v2021-10-21/data/query/production?${params.toString()}`,
    {
      headers: {
        'Authorization': `Bearer ${process.env.GATSBY_SANITY_SOURCE_TOKEN}`,
        'Content-Type': 'application/json',
      },
    }
  ).then(res => {
    return res.json()
  })
}

module.exports = { query }
